import styled from "@emotion/styled";
import { fontMerriweather, fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)``;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  margin-block-end: 40px;
`;

export const HeadlineContainer = styled.div`
  padding-inline-start: 12px;
  border-inline-start: 1px solid #222222;
`;

export const HighlightText = styled.div`
  display: inline-block;

  padding-block: 0;
  padding-inline: 2px;

  color: #000000;
  font-weight: 900;
  font-size: 12px;
  font-family: ${fontMerriweather};
  line-height: 15px;
  text-transform: uppercase;

  background-color: #ffca05;
`;

export const Headline = styled.div`
  margin-block-start: 8px;

  color: #000000;
  font-weight: 300;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  :hover {
    text-decoration-line: underline;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const Indicator = styled.div`
  margin-block-start: 24px;

  color: #999999;
  font-weight: normal;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;

  strong {
    display: inline-block;

    inline-size: 28px;
    block-size: 28px;

    color: #ffffff;
    font-weight: normal;
    line-height: 28px;
    text-align: center;

    background-color: #000000;
  }
`;
